<template>
  <div class="about">
    <h1>A site for altruistic events!</h1>
  </div>
</template>
